import type { BffPhysicalDeviceResourceReadApi } from '@ingenico/api-sdk-provisioning-private';
import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import { DeviceImageMapper } from '@ingenico/react-ui/device-image-mapper';
import deepEqual from 'fast-deep-equal';
import { capitalize } from 'lodash-es';
import type { ReactElement } from 'react';
import { memo } from 'react';
import type { PhysicalDeviceInformation } from '../../domain/models/physicalDeviceInformation.model';
import styles from './tetraDeviceInfoCard.module.scss';
import { useTetraDeviceInfoCard } from './useTetraDeviceInfoCard';

interface TetraDeviceInfoCardProps {
  readonly physicalDevice?: PhysicalDeviceInformation | null;
  readonly attachedPhysicalDevice?: BffPhysicalDeviceResourceReadApi | null;
}

function TetraDeviceInfoCardCpnt({ physicalDevice, attachedPhysicalDevice }: TetraDeviceInfoCardProps): ReactElement {
  const { image, model, brand, type } = useTetraDeviceInfoCard({ physicalDevice, attachedPhysicalDevice });

  return (
    <div className={styles.tetraDeviceInfo}>
      <div className={styles.tetraDeviceInfo__imageColumn}>
        <div className={styles.tetraDeviceInfo__imageWrapper}>
          <div className={styles.tetraDeviceInfo__imageContainer}>
            <DeviceImageMapper customClass={styles.tetraDeviceInfo__image} image={image} />
          </div>
        </div>
      </div>
      <div className={styles.tetraDeviceInfo__infoColumn}>
        <div className={styles.tetraDeviceInfo__infoWrapper}>
          {model ? <CoreTypography variant={CoreTypographyVariant.Headline02Bold}>{model}</CoreTypography> : '_'}

          <CoreTypography variant={CoreTypographyVariant.Body02Regular}>
            {capitalize(brand)} {capitalize(type)}
          </CoreTypography>
        </div>
      </div>
    </div>
  );
}

export const TetraDeviceInfoCard = memo(TetraDeviceInfoCardCpnt, deepEqual);
